import { Component, OnInit, ElementRef, Input } from '@angular/core';
import {UserService} from "../../services/userService";
import {Router} from "@angular/router";
import {StorageManager} from "../../common/managers/storageManager";
import {Location} from '@angular/common';
import { BaseMenuComponent } from "../../common/menu/baseMenuComponent";

@Component({
    moduleId: module.id,
    selector: 'navbar',
    templateUrl: 'navbar.component.html'
})
export class NavbarComponent extends BaseMenuComponent implements OnInit {
    @Input() public isMobileMenu: boolean;
    public userName: Promise<string>;
    public admin: boolean = false;

    constructor(private element: ElementRef, router: Router, storageManager: StorageManager, private location: Location) {
        super(storageManager,router);

        this.sidebarVisible = false;
    }

    ngOnInit(): void {
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        this.userName = this.storageManager.getCurrentUser().then(user => {
            // this.admin = user.Roles.indexOf(1) > -1 || user.Roles.indexOf(13) > -1;
            return user.Email;
        });
    }



    public stepBack(): void {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./app/components/navbar/navbar.component.ts